import { ModulosEnum } from '@/enums/ModulosEnum'
import { useSessionStore } from '@/stores/components/sessionStore'
//import type { Modulo } from '@/stores/components/sessionStore'

/**
 * Verifica se um módulo específico existe para a empresa
 * @param moduleCodes Código do módulo (pode ser string ou valor do enum ModulosEnum)
 * @returns boolean indicando se o módulo existe
 */
export function checkModules(moduleCodes: ModulosEnum[] | string[], modules_operator: 'AND' | 'OR' = 'AND', options = { like: false }): boolean {
  const sessionStore = useSessionStore()

  if (!sessionStore.userData?.modulos) {
    return false
  }

  try {

    options.like = options.like || false;

    if(modules_operator === 'AND') {

      let allModulesFound = true

      moduleCodes.forEach((code) => {

        if(options.like) {
          if (!sessionStore?.userData?.modulos.some((mod: any) => mod.codigo.includes(code))) {
            allModulesFound = false
          }
        }else{
          const modulo = sessionStore?.userData?.modulos.find(
            (mod: any) => mod.codigo === code
          )
          if (!modulo) {
            allModulesFound = false
          }
        }

      })

      return allModulesFound

    } else if(modules_operator === 'OR') {

      let anyModuleFound = false

      moduleCodes.forEach((code) => {

        if(options.like) {
          if (sessionStore?.userData?.modulos.some((mod: any) => mod.codigo.includes(code))) {
            anyModuleFound = true
          }
        }else{
          const modulo = sessionStore?.userData?.modulos.find(
            (mod: any) => mod.codigo === code
          )
          if (modulo) {
            anyModuleFound = true
          }
          if (modulo) {
            anyModuleFound = true
          }
        }

      })
      
      return anyModuleFound

    }

    return false
    
  } catch (error) {
    console.error('Erro ao verificar módulo:', error)
    return false
  }
}

/**
 * Verifica se um módulo específico está ativo para a empresa atual
 * @param moduleCode Código do módulo (pode ser string ou valor do enum ModulosEnum)
 * @returns boolean indicando se o módulo está ativo
 */
export function checkModuleActive(moduleCode: ModulosEnum | string): boolean {
  const sessionStore = useSessionStore()

  if (!sessionStore.userData?.modulos /* TODO: RE-HABILITAR AQUI PARA TRAVAR PLANO PADRÂO || sessionStore?.currentPlan?.pla_descricao?.includes('Padrão') */) {
    return false
  }

  try {
    const modulo = sessionStore.userData.modulos.find(
      (mod: any) => mod.codigo === moduleCode
    )

    return modulo ? modulo.ativo : false
  } catch (error) {
    console.error('Erro ao verificar módulo:', error)
    return false
  }
}

/**
 * Verifica se pelo menos um dos módulos da lista está ativo
 * @param moduleCodes Array de códigos de módulos
 * @returns boolean indicando se pelo menos um módulo está ativo
 */
export function checkAnyModuleActive(
  moduleCodes: (ModulosEnum | string)[]
): boolean {
  return moduleCodes.some((moduleCode) => checkModuleActive(moduleCode))
}

/**
 * Verifica se todos os módulos da lista estão ativos
 * @param moduleCodes Array de códigos de módulos
 * @returns boolean indicando se todos os módulos estão ativos
 */
export function checkAllModulesActive(
  moduleCodes: (ModulosEnum | string)[]
): boolean {
  return moduleCodes.every((moduleCode) => checkModuleActive(moduleCode))
}

/**
 * Retorna todos os módulos ativos da empresa atual
 * @returns Array de módulos ativos
 */
export function getActiveModules(): Modulo[] {
  const sessionStore = useSessionStore()

  if (!sessionStore.userData?.modulos) {
    return []
  }

  return sessionStore.userData.modulos.filter((modulo) => modulo.ativo)
}

/**
 * Retorna todos os códigos dos módulos ativos
 * @returns Array de strings com os códigos dos módulos ativos
 */
export function getActiveModuleCodes(): string[] {
  return getActiveModules().map((modulo) => modulo.codigo)
}

/**
 * Verifica se um módulo específico existe (independente de estar ativo ou não)
 * @param moduleCode Código do módulo
 * @returns boolean indicando se o módulo existe
 */
export function moduleExists(moduleCode: ModulosEnum | string): boolean {
  const sessionStore = useSessionStore()

  if (!sessionStore.userData?.modulos) {
    return false
  }

  return sessionStore.userData.modulos.some(
    (modulo: Modulo) => modulo.codigo === moduleCode
  )
}

/**
 * Retorna as informações completas de um módulo
 * @param moduleCode Código do módulo
 * @returns Objeto Modulo ou null se não encontrado
 */
export function getModuleInfo(moduleCode: ModulosEnum | string): Modulo | null {
  const sessionStore = useSessionStore()

  if (!sessionStore.userData?.modulos) {
    return null
  }

  return (
    sessionStore.userData.modulos.find(
      (modulo: Modulo) => modulo.codigo === moduleCode
    ) || null
  )
}
